import React, { useEffect } from "react";
import { View, ScrollView, Platform } from "react-native";
import { styles } from "../style/styles.js";

const DetailsScreen = () => {
  return <ScrollView style={styles.backgrounOption}></ScrollView>;
};

export default DetailsScreen;
